import {useCallback, useEffect} from 'react';

import {getCompanyById} from '/src/openapi/ccdb-bff/apis/CompaniesApi';
import {useAppDispatch, useAppSelector} from '/src/store/hooks';

export const useCompanyDetail = (companyId: string | undefined) => {
    const dispatch = useAppDispatch();
    const {selectedCompany, detailLoading, error} = useAppSelector(state => state.ccdbCompanySearch);

    const loadCompany = useCallback((id: string) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dispatch(getCompanyById({companyId: id}) as any);
    }, [dispatch]);

    useEffect(() => {
        if (companyId) {
            loadCompany(companyId);
        }
    }, [companyId, loadCompany]);

    return {
        company: selectedCompany,
        loading: detailLoading,
        error,
        loadCompany,
    };
};
